import { Modals } from 'presentation/libs/modals'

const MODAL_KEY = 'CompsViewSettingsModal'

export const useCompsViewSettingsModal = Modals.createHistoryUseModal(MODAL_KEY)
